/**
 * kaynak-referans RegexUtils paritesi (1:1 port) — messaging/utils/RegexUtils.ts.
 *
 * Kullanıcı girdisini RegExp içine gömerken meta-karakterleri kaçış'lar.
 * CodeLinkUtils gibi dinamik pattern üreten yardımcılar tarafından kullanılır.
 */

/** RegExp meta-karakterlerini kaçış'layarak string'i literal-eşleşir hale getirir. */
export function escapeRegex(str: string): string {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
